import { useEffect, useState, JSX } from "react";
import {
  AddCerosToNumber,
  SubFirstCaracter,
  filtrarNombresUnicos,
} from "../actions/actions";
import { IModalidades, INumeroExtracto } from "../interfaces/interfaces";
import ResumenPoceada from "./resumenPoceada";
import { v4 as uuid } from "uuid";

interface Props {
  lastHeadExtractos: IModalidades[];
  numerosExtractos: INumeroExtracto[];
  stateProxSorteo: number;
}

const GrillaResumen = (props: Props) => {
  const { lastHeadExtractos, numerosExtractos, stateProxSorteo } = props;
  let loteriasNombreId = filtrarNombresUnicos(numerosExtractos);
  const [headPoceada, setHeadPoceada] = useState<IModalidades[]>([]);

  useEffect(() => {
    setHeadPoceada([
      ...lastHeadExtractos.filter((numero) => numero.idModalidad === 30),
    ]);
  }, [lastHeadExtractos]);

  return (
    <>
      <div id="pocProx">
        <ResumenPoceada
          headsPoceada={headPoceada}
          numerosExtractos={numerosExtractos}
          stateProxSorteo={stateProxSorteo}
        />
      </div>
      <div className="contenedorResumenAyer">
        <table id="ResumenAyer">
          <thead>
            <tr>
              <th style={{ color: "white" }}>Ultimos 1º</th>
              {loteriasNombreId && getHeadModalidad(loteriasNombreId)}
            </tr>
          </thead>
          <tbody>
            {lastHeadExtractos &&
              getNumerosModalidad(
                lastHeadExtractos,
                numerosExtractos,
                loteriasNombreId
              )}
          </tbody>
        </table>
      </div>
    </>
  );

  function getHeadModalidad(
    loteriasNombreId: { id: number; Nombre: string }[]
  ) {
    let array: JSX.Element[] = [];
    for (const i of loteriasNombreId) {
      let keyC = `colkeyth${i.id}${uuid()}`;
      let nombreLoteria = i.Nombre;
      if (i.id === 3) nombreLoteria = "Bs. As.";
      if (i.id === 4) nombreLoteria = "Oro(Uru)";

      array.push(
        <th key={keyC} className="tablaHeadResaltado">
          {nombreLoteria}
        </th>
      );
    }
    return array;
  }

  function getNumerosModalidad(
    headExtractoModalidad: IModalidades[],
    numerosExtractos: INumeroExtracto[],
    loteriasNombreId: { id: number; Nombre: string }[]
  ) {
    let array: JSX.Element[] = [];
    let arrayTR: JSX.Element[] = [];

    for (const i of headExtractoModalidad) {
      let keyC = `colkeym${i.idModalidad}${uuid()}`;
      let numerosModalidad = getNumerosPorModalidadUnos(
        i.idModalidad,
        numerosExtractos
      );

      for (const loteria of loteriasNombreId) {
        let keyC = `colkeyL${loteria.id}${uuid()}`;

        let numForLoteModa = numerosModalidad.find(
          (numero) => numero.NroLoteria === loteria.id
        );

        if (numForLoteModa) {
          let numeroLoteria = AddCerosToNumber(numForLoteModa.Valor, 4);
          if (numForLoteModa.NroLoteria === 4) {
            numeroLoteria = SubFirstCaracter(numeroLoteria);
          }
          array.push(
            <td key={keyC} className="tablaNumeroResaltado">
              {numeroLoteria}
            </td>
          );
        } else {
          array.push(<td key={keyC} className="tablaNumeroResaltado"></td>);
        }
      }
      i.idModalidad !== 30 &&
        arrayTR.push(
          <tr key={`${keyC}`}>
            <td className="tablaHeadResaltado">
              {`${i.Modalidad}`.replace("Tómbola", "")}
            </td>
            {array}
          </tr>
        );
      array = [];
    }

    return arrayTR;
  }
};

function getNumerosPorModalidadUnos(
  idModalidad: number,
  numerosExtractos: INumeroExtracto[]
) {
  return [
    ...numerosExtractos.filter(
      (numero) =>
        numero.idModalidad !== 30 &&
        numero.idModalidad === idModalidad &&
        numero.Ubicacion === 1
    ),
  ];
}
export default GrillaResumen;
